import loadData from './load-data';
import lang from './lang';
import util from './_utils';
import {
	Utils
} from 'handlebars';
import {
	SSL_OP_ALL
} from 'constants';

const container = d3.select('.graphic__chart'),
	rightPanel = d3.select('.graphic__right'),
	bottomPanel = d3.select('.bottom__panel-aspirations'),
	goBackButton = bottomPanel.select('.aspirations-go-back'),
	header = d3.select('.viz-header'),
	svg = container.select('.svg__aspirations'),
	g = svg.select('.aspirations'),
	g_bubbles = g.select('.bubbles'),
	defs = svg.append('svg:defs'),
	topPanel = d3.select('.top-panel');

let margin, x, y, r, w, h, playR = 20,
	view = 'all';

let baseData, data, featuredData, otherData, vizParameters, isMobile, windowW, drawn = false,
	currentAthlete = null;

let simulation, simulationFeatured, simulationOther, bubbles, bubble_gs, featuredBubbleGs, otherBubbleGs;

let currentAudio = null;

const featured = [{
	name: 'User 1--Name',
	title: 'User 1--Title',
	id: 'mirna',
	img: './assets/images/featured-athletes/mirna.jpg',
	imgLarge: './assets/images/featured-athletes/mirna.jpg'
}, {
	name: 'User 2--Name',
	title: 'User 2--Title',
	id: 'martin',
	img: './assets/images/featured-athletes/martin.jpg',
	imgLarge: './assets/images/featured-athletes/martin.jpg'
}, {
	name: 'User 3--Name',
	title: 'User 3--Title',
	id: 'mary-kate',
	img: './assets/images/featured-athletes/mary-kate.jpg',
	imgLarge: './assets/images/featured-athletes/mary-kate.jpg'
}, {
	name: 'User 4--Name',
	title: 'User 4--Title',
	id: 'megan',
	img: './assets/images/featured-athletes/megan.jpg',
	imgLarge: './assets/images/featured-athletes/megan.jpg'
}];

const audioPaths = {
	'mirna': './assets/audio/mirna.mp3',
	'martin': './assets/audio/martin.mp3',
	'mary-kate': './assets/audio/mary-kate.mp3',
	'megan': './assets/audio/megan.mp3',
}

const duration = {
		fast: 250,
		medium: 500,
		slow: 1000,
		reallySlow: 5000
	},
	forceStrength = .4;

const chapter = 'aspirations';

let step = 0,
	location = 'center';

function next(index) {
	step = index + 1;

	if (!drawn) {
		draw();
	} else {
		update();
	}
}

function init() {
	step = 0;

	svg.style('pointer-events', 'none');

	return new Promise((resolve, reject) => {
		Promise.all([
			loadData(['aspirations.csv'])
		]).then(function(result) {
			baseData = util.parseData(result[0][0]);

			setup();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function setup(resize = false) {
	isMobile = util.isMobile();
	windowW = util.windowWidth();
	vizParameters = getVizParameters();

	data = formatData(baseData);
	featuredData = formatData(baseData, true)[0];
	otherData = formatData(baseData, true)[1];

	margin = {
		top: vizParameters.headerH + (isMobile ? 25 : 50),
		right: 0,
		bottom: 0,
		left: 0
	}

	w = vizParameters.outerW - margin.right - margin.left;
	h = vizParameters.outerH - margin.top - margin.bottom;

	//r = d3.scaleSqrt().domain([0, 30, 100]).range([isMobile ? 2 : 5, isMobile ? 10 : 20, vizParameters.rMax]);
	r = d3.scaleSqrt().domain([0, 100]).range([0, vizParameters.rMax]);

	const massCoords = getMassCoords(location);

	data.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		d.y = vizParameters.outerH * Math.random();
		/*
		d.r = r(d.val);
		d.startR = r(d.val);
		*/
		d.r = d.val;
		d.startR = d.val;
	})

	featuredData.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		d.y = vizParameters.outerH * Math.random();
		/*
		d.r = r(d.val);
		d.startR = r(d.val);
		*/
		d.r = d.val;
		d.startR = d.val;
	})

	otherData.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		d.y = vizParameters.outerH * Math.random();
		/*
		d.r = r(d.val);
		d.startR = r(d.val);
		*/
		d.r = d.val;
		d.startR = d.val;
	})

	g.attr('transform', `translate(${margin.left}, ${margin.top})`);

	defs.selectAll('.defs-bg-image')
		.data(data)
		.enter()
		.append('svg:pattern')
		.attr('class', 'defs-bg-image')
		.attr('id', d => `bg-image--${d.id}`)
		.attr('width', 1)
		.attr('height', 1)
		.attr('viewBox', d => `0 0 ${d.r*2} ${d.r*2}`)
		.append('svg:image')
		.attr('xlink:href', d => d.img)
		.attr('preserveAspectRatio', 'xMidYMid slice')
		.attr('width', d => d.r * 2)
		.attr('height', d => d.r * 2)
		.attr('x', 0)
		.attr('y', 0);

	defs.selectAll('.defs-bg-image-large')
		.data(data)
		.enter()
		.append('svg:pattern')
		.attr('class', 'defs-bg-image-large')
		.attr('id', d => `bg-image-large--${d.id}`)
		.attr('width', 1)
		.attr('height', 1)
		.append('svg:image')
		.attr('xlink:href', d => d.imgLarge)
		.attr('preserveAspectRatio', 'xMidYMid slice')
		.attr('width', d => vizParameters.rMax * 4)
		.attr('height', d => vizParameters.rMax * 4)
		.attr('x', 0)
		.attr('y', 0);

	let filterDef = defs.append('filter')
		.attr('id', 'dropshadow')

	filterDef.append('feGaussianBlur')
		.attr('in', 'SourceAlpha')
		.attr('stdDeviation', 2)
		.attr('result', 'blur')
		.attr('width', '250%')
		.attr('height', '500%');

	filterDef.append('feOffset')
		.attr('in', 'blur')
		.attr('dx', 0)
		.attr('dy', 5)
		.attr('result', 'offsetBlur');

	filterDef.append('feFlood')
		.attr('in', 'offsetBlur')
		.attr('flood-color', '#000')
		.attr('flood-opacity', '.2')
		.attr('result', 'offsetColor');

	filterDef.append('feComposite')
		.attr('in', 'offsetColor')
		.attr('in2', 'offsetBlur')
		.attr('operator', 'in')
		.attr('result', 'offsetBlur');

	let feMerge = filterDef.append('feMerge');

	feMerge.append('feMergeNode')
		.attr('in', 'offsetBlur');
	feMerge.append('feMergeNode')
		.attr('in', 'SourceGraphic');

	topPanel.selectAll('.top-panel--aspirations__filter-button').on('click', function() {
		const newView = d3.select(this).attr('data-view');

		if (newView !== view) {
			if (newView == 'all' && view !== 'other') {
				util.skipStep(-1)
			} else if (newView == 'other' && view !== 'all') {
				util.skipStep(-1)
			} else if (newView == 'featured') {
				util.skipStep(0)
			} else if (newView == 'other') {
				util.skipStep(1)
			}
		}

		view = newView;

		unhighlightFeaturedAthlete();
		filter();

		topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', false);
		d3.select(this).classed('is-active', true);
	})

	if (resize) {
		resizeAspirations();
	} else {
		// draw();
	}
}

function draw() {
	drawn = true;
	svg.style('pointer-events', 'all');

	data.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		//d.y = vizParameters.outerH * Math.random();
		d.y = util.randomNumber(vizParameters.outerH, vizParameters.outerH * 2);
		d.r = d.startR
	})

	featuredData.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		//d.y = vizParameters.outerH * Math.random();
		d.y = util.randomNumber(vizParameters.outerH, vizParameters.outerH * 2);
		d.r = d.startR
	})

	otherData.forEach(d => {
		d.x = vizParameters.outerW * Math.random();
		//d.y = vizParameters.outerH * Math.random();
		d.y = util.randomNumber(vizParameters.outerH, vizParameters.outerH * 2);
		d.r = d.startR
	})

	simulation = d3.forceSimulation()
		.alphaDecay(.0005).velocityDecay(0.8)
		.force('charge', d3.forceManyBody().strength(d => charge(d)))
		.on('tick', ticked);

	simulationFeatured = d3.forceSimulation()
		.alphaDecay(.0005).velocityDecay(0.8)
		.force('charge', d3.forceManyBody().strength(d => chargeStronger(d)))
		.on('tick', reTicked);

	simulationOther = d3.forceSimulation()
		.alphaDecay(.0005).velocityDecay(0.8)
		.force('charge', d3.forceManyBody().strength(d => charge(d)))
		.on('tick', reTicked);

	simulation.stop();
	simulationFeatured.stop();
	simulationOther.stop();

	bubble_gs = g_bubbles.selectAll('.bubble-g')
		.data(data, d => d.id);

	const bubble_gsE = bubble_gs.enter().append('g')
		.classed('bubble-g', true);

	g_bubbles.selectAll('.bubble-g').append('circle')
		.classed('bubble', true)
		.attr('r', 0)
		.style('fill', d => d.color).style('fill', d => d.featured ? `url(#bg-image--${d.id})` : d.color)
		.style('stroke', d => d.featured ? 'none' : '#242428')
		.style('cursor', d => !d.fake ? 'pointer' : 'default');

	bubble_gs = bubble_gs.merge(bubble_gsE);

	bubble_gs.selectAll('.bubble').transition().duration(duration.slow)
		.attr('r', d => d.r);

	simulation.nodes(data);

	const featuredGs = bubble_gs.filter(d => d.featured).moveToFront(),
		otherGs = bubble_gs.filter(d => !d.featured && !d.fake);

	featuredGs.select('.bubble').on('click', d => {
		if (d.name !== currentAthlete) {
			currentAthlete = d.name;
			util.showAthlete(currentAthlete)
		}
	});

	otherGs.on('click', highlightquote);

	featuredGs.append('circle')
		.attr('class', 'play-button-bg')
		.attr('cx', d => d.r * (.75)).attr('cy', d => d.r * (.75)).attr('r', 0)
		.attr('prev-cx', function(d) {
			return d3.select(this).attr('cx');
		})
		.attr('prev-cy', function(d) {
			return d3.select(this).attr('cy');
		})
		.style('fill', '#F8621F')
		.on('click', play)
		.transition().duration(duration.medium)
		.attr('r', playR)
		.style('filter', 'url(#dropshadow)').style('cursor', 'pointer');

	featuredGs.append('svg:image')
		.attr('class', 'play-button')
		.attr('x', d => d.r * .75 - 7.5).attr('y', d => d.r * .75 - 10)
		.attr('prev-x', function(d) {
			return d3.select(this).attr('x');
		})
		.attr('prev-y', function(d) {
			return d3.select(this).attr('y');
		})
		.attr('width', 20).attr('height', 20)
		.attr('xlink:href', './assets/images/play.svg')
		.style('opacity', 0).style('pointer-events', 'none')
		.transition().duration(duration.medium)
		.style('opacity', 1);

	moveMass();
}

function filter(newView = view) {
	topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', false);
	topPanel.selectAll(`[data-view='${view}']`).classed('is-active', true);

	if (view == 'featured') {
		featuredLabels();
	} else {
		util.hideAthletes();
		removeFeaturedLabels();
	}

	g_bubbles.selectAll('.aspirations-quote').remove();

	if (view != 'all') {
		featuredData.forEach(d => {
			d.r = d.startR;
		});

		otherData.forEach(d => {
			d.r = d.startR;
		});

		simulationFeatured.stop();
		simulationOther.stop();

		featuredBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => d.featured)
			.data(featuredData, d => d.id);

		featuredBubbleGs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		featuredBubbleGs.merge(featuredBubbleGs);

		featuredBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.startR);

		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id)

		otherBubbleGs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		otherBubbleGs.merge(otherBubbleGs);

		otherBubbleGs.selectAll('.bubble')
			.style('pointer-events', view === 'featured' ? 'none' : 'all')
			.transition().duration(duration.medium)
			.attr('r', d => d.startR);

		simulationFeatured.nodes(featuredData);
		simulationOther.nodes(otherData);

		//	view == 'featured' ? moveFeaturedMassStatic() : moveFeaturedMass('bottomCenter');
		moveFeaturedMass(view == 'featured' ? 'organized' : 'outOfView');
		moveOtherMass(view == 'featured' ? 'dispersed' : 'topCenter');

	} else {
		data.forEach(d => {
			d.r = d.startR;
		});

		simulation.stop();

		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').style('pointer-events', 'all');

		simulation.nodes(data);

		moveMass();
	}

}

function update() {
	featuredBubbleGs = g_bubbles.selectAll('.bubble-g');
	otherBubbleGs = g_bubbles.selectAll('.bubble-g');

	if (step == 0) {
		view = 'all';
		unhighlightFeaturedAthlete();
		filter();

		topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', function() {
			return d3.select(this).attr('data-view') === 'all';
		});
	}

	if (step == 1) {
		view = 'featured';
		unhighlightFeaturedAthlete();
		filter();

		topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', function() {
			return d3.select(this).attr('data-view') === 'featured';
		});
	}

	if (step == 2) {
		view = 'other';
		unhighlightFeaturedAthlete();
		filter();

		topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', function() {
			return d3.select(this).attr('data-view') === 'other';
		});
	}
}

function end() {
	goback(false);
	if (drawn) {
		svg.style('pointer-events', 'none');
		bubble_gs = g_bubbles.selectAll('.bubble-g').data([]);

		bubble_gs.exit().selectAll('circle').transition().duration(duration.medium).attr('r', 0).remove();
		bubble_gs.exit().selectAll('.play-button').transition().duration(duration.medium).attr('width', 0).attr('height', 0).remove();
		bubble_gs.exit().transition().delay(duration.medium).remove();

		pause();

		drawn = false;
	}
}

function clear() {
	g_bubbles.selectAll('.bubble-g').remove();

	goback(false);
	pause();

	drawn = false;
	view = 'all';

	topPanel.selectAll('.top-panel--aspirations__filter-button').classed('is-active', function() {
		const thisView = d3.select(this).attr('data-view');
		return thisView === 'all';
	});
}

function highlightquote(d) {
	util.hideAthletes();
	g_bubbles.selectAll('.aspirations-quote').remove();

	simulation.stop();
	simulationFeatured.stop();
	simulationOther.stop();

	data.forEach(s => {
		s.r = s.startR;
	});

	otherData.forEach(s => {
		s.r = s.startR;
	});

	const thisBubble = bubble_gs.filter(s => s.id == d.id);

	const textWidth = (Math.min(vizParameters.outerW, vizParameters.outerH) * .7),
		limitTextWidth = Math.min(500, textWidth);

	thisBubble.append('text')
		.attr('class', 'aspirations-quote aspirations-quote--text')
		.attr('x', 0)
		.attr('y', 0)
		.text(d => d.quote)
		.call(wrap, limitTextWidth);

	let textBB = thisBubble.select('.aspirations-quote--text').node().getBBox();

	if (textBB.height > vizParameters.outerH * .8 || textBB.width > vizParameters.outerW * .95) {
		thisBubble.select('.aspirations-quote--text').remove();

		thisBubble.append('text')
			.attr('class', 'aspirations-quote aspirations-quote--text')
			.attr('x', 0)
			.attr('y', 0)
			.text(d => {
				const shortQuote = getShortQuote();
				return shortQuote;
			})
			.call(wrap, limitTextWidth);

		textBB = thisBubble.select('.aspirations-quote--text').node().getBBox();
	}

	/*
	if (textBB.width > vizParameters.outerW * .95) {
		thisBubble.select('.aspirations-quote--text').remove();

		thisBubble.append('text')
			.attr('class', 'aspirations-quote aspirations-quote--text')
			.attr('x', 0)
			.attr('y', 0)
			.text(d => {
				const quote = d.quote;
				const shortenedQuote = quote.substring(0, 20) + '...'
				return shortenedQuote;
			})
			.call(wrap, limitTextWidth);

		textBB = thisBubble.select('.aspirations-quote--text').node().getBBox();
	}
	*/

	thisBubble.select('.aspirations-quote--text')
		.attr('transform', `translate(0, ${-textBB.height / 2})`);

	thisBubble.append('text')
		.attr('class', 'aspirations-quote aspirations-quote--mark')
		.text('“')
		.attr('text-anchor', 'end')
		.attr('transform', `translate(${-textBB.width / 2}, ${-textBB.height / 2})`);

	const yOffset = windowW > 800 ? 35 : 10,
		rOffset = windowW > 800 ? 100 : 40;

	thisBubble.append('text')
		.attr('class', 'aspirations-quote aspirations-quote--mark')
		.text('”')
		.attr('text-anchor', 'start')
		.attr('transform', `translate(${textBB.width / 2}, ${textBB.height / 2 + yOffset})`);

	const circleRadius = 0.5 * Math.sqrt(textBB.width * textBB.width + textBB.height * textBB.height) + rOffset;

	if (view == 'all') {
		data.forEach(s => {
			s.r = s.id == d.id ? circleRadius : s.startR;
		});

		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.r);

		simulation.nodes(data).alpha(.8).restart();

	} else if (view == 'other') {
		otherData.forEach(s => {
			s.r = s.id == d.id ? circleRadius : s.startR;
		});

		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id);

		otherBubbleGs.merge(otherBubbleGs);

		otherBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', s => s.id === d.id ? circleRadius : s.r);

		simulationOther.nodes(otherData).alpha(.8).restart();
	}

	goback(true);
}

function unhighlightquote() {
	g_bubbles.selectAll('.aspirations-quote').transition().duration(duration.medium).style('opacity', 0).remove();

	simulation.stop();
	simulationOther.stop();

	data.forEach(s => {
		s.r = s.startR;
	});

	otherData.forEach(s => {
		s.r = s.startR;
	});

	if (view == 'all') {
		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.r);

		simulation.nodes(data).alpha(.8).restart();

	} else if (view == 'other') {
		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id);

		otherBubbleGs.merge(otherBubbleGs);

		otherBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.r);

		simulationOther.nodes(otherData).alpha(.8).restart();
	}

	goback(false);
}

function highlightFeaturedAthlete(athlete) {
	currentAthlete = athlete;

	pause(athlete);

	if (view == 'other') {
		view = 'featured';
		removeFeaturedLabels();
		filter();
	}

	unhighlightquote();

	simulation.stop();
	simulationOther.stop();
	simulationFeatured.stop();

	if (view == 'all') {
		data.forEach(s => {
			s.r = s.name == athlete ? vizParameters.rMax * 2 : s.startR;
		});

		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => {
				return d.name == athlete ? vizParameters.rMax * 2 : d.r;
			})
		//.style('fill', d => d.color).style('fill', s => s.featured ? (s.name == athlete ? `url(#bg-image--${s.id})` : `url(#bg-image--${s.id})`) : s.color);

		simulation.nodes(data).alpha(.8).restart();

	} else if (view == 'featured') {
		otherData.forEach(s => {
			s.r = s.startR;
		});

		featuredData.forEach(s => {
			s.r = s.name == athlete ? vizParameters.rMax * 2 : s.startR;
		});

		featuredBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => d.featured)
			.data(featuredData, d => d.id);

		featuredBubbleGs.merge(featuredBubbleGs);

		featuredBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.name == athlete ? vizParameters.rMax * 2 : d.startR)
			.style('fill', d => d.color).style('fill', s => s.featured ? (s.name == athlete ? `url(#bg-image--${s.id})` : `url(#bg-image--${s.id})`) : s.color);

		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id);

		otherBubbleGs.merge(otherBubbleGs);

		simulationFeatured.nodes(featuredData).alpha(.8).restart();
		//simulationOther.nodes(otherData).alpha(.8).restart();
	}

	// bubble_gs.filter(d => d.name == athlete).append('circle')
	// 	.attr('class', 'featured-image-overlay')
	// 	.attr('cx', 0).attr('cy', 0).attr('r', d => d.startR)
	// 	.style('fill', d => d.color).style('fill', d => `url(#bg-image-large--${d.id})`)
	// 	.transition().duration(duration.medium)
	// 	.attr('r', d => d.r);

	//unhighlightquote();
	goback(true);

	bubble_gs.filter(s => s.featured && s.name == athlete)
		.select('.play-button-bg')
		.attr('r', playR * 1.25);

	g_bubbles.selectAll('.aspirations-label')
		.transition().duration(duration.medium)
		.style('opacity', 0);

	g_bubbles.selectAll('.play-button-bg')
		.transition().duration(duration.medium)
		// .attr('cx', s => s.name == athlete ? 0 : s.r * (.75))
		// .attr('cy', s => s.name == athlete ? vizParameters.rMax * 2 : s.r * (.75))
		.attr('cx', function(d) {
			return d.name == athlete ? 0 : d3.select(this).attr('prev-cx');
		})
		.attr('cy', function(d) {
			return d.name == athlete ? vizParameters.rMax * 2 : d3.select(this).attr('prev-cy');
		})
		.attr('r', s => s.name == athlete ? playR * 1.25 : playR);

	g_bubbles.selectAll('.play-button')
		.transition().duration(duration.medium)
		// .attr('x', s => s.name == athlete ? -7.5 : s.r * .75 - 7.5)
		// .attr('y', s => s.name == athlete ? vizParameters.rMax * 2 - 10 : s.r * .75 - 10);
		.attr('x', function(d) {
			return d.name == athlete ? -7.5 : d3.select(this).attr('prev-x');
		})
		.attr('y', function(d) {
			return d.name == athlete ? vizParameters.rMax * 2 - 10 : d3.select(this).attr('prev-y');
		});

	g_bubbles.selectAll('.play-button-bg, .play-button').moveToFront();
}

function unhighlightFeaturedAthlete() {
	goback(false);

	if (view == 'all' && drawn) {
		data.forEach(s => {
			s.r = s.startR;
		});

		simulation.stop();

		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.r)
			.style('fill', d => d.color).style('fill', s => s.featured ? `url(#bg-image--${s.id})` : s.color);

		simulation.nodes(data).alpha(.8).restart();

	} else if (view == 'featured' && drawn) {
		simulationFeatured.stop();
		simulationOther.stop();

		data.forEach(s => {
			s.r = s.startR;
		});

		featuredData.forEach(s => {
			s.r = s.startR;
		});

		otherData.forEach(s => {
			s.r = s.startR;
		});

		featuredBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => d.featured)
			.data(featuredData, d => d.id);

		featuredBubbleGs.merge(featuredBubbleGs)
			.style('fill', d => d.color).style('fill', d => d.featured ? `url(#bg-image--${d.id})` : d.color);

		featuredBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.r)
			.style('fill', d => d.color).style('fill', s => s.featured ? `url(#bg-image--${s.id})` : s.color);

		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id);

		otherBubbleGs.merge(otherBubbleGs);

		simulationFeatured.nodes(featuredData).alpha(.8).restart();
		simulationOther.nodes(otherData).alpha(.8).restart();
	}

	if (drawn) {
		// bubble_gs.selectAll('.play-button-bg').attr('r', playR)
		g_bubbles.selectAll('.featured-image-overlay').transition().duration(duration.medium).attr('r', d => d.startR).remove();
		g_bubbles.selectAll('.aspirations-label').transition().duration(duration.medium).style('opacity', 1);
		g_bubbles.selectAll('.play-button').transition().duration(duration.medium)
			// .attr('x', d => d.r * .75 - 7.5).attr('y', d => d.r * .75 - 10);
			.attr('x', function() {
				return d3.select(this).attr('prev-x');
			})
			.attr('y', function() {
				return d3.select(this).attr('prev-y');
			});

		g_bubbles.selectAll('.play-button-bg').transition().duration(duration.medium)
			.attr('cx', function() {
				return d3.select(this).attr('prev-cx');
			})
			.attr('cy', function() {
				return d3.select(this).attr('prev-cy');
			})
			// .attr('cx', d => d.r * .75)
			// .attr('cy', d => d.r * .75)
			.attr('r', playR);

		pause();
	}
}

function play(d) {
	if (d.name !== currentAthlete) {
		currentAthlete = d.name;
		util.showAthlete(currentAthlete);
	}

	if (currentAudio) currentAudio.pause();

	bubble_gs.filter(s => s.featured && s.name == d.name).select('.play-button').attr('xlink:href', './assets/images/pause.svg').attr('transform', 'translate(-2, 0)');

	bubble_gs.filter(s => s.featured && s.name == d.name).select('.play-button-bg').on('click', pause);

	// play audio
	const audioPath = audioPaths[d.id];
	currentAudio = new Audio(audioPath);
	currentAudio.play();
}

function pause() {
	d3.selectAll('.play-button-bg').on('click', play);
	d3.selectAll('.play-button').attr('xlink:href', './assets/images/play.svg').attr('transform', 'translate(0,0)')
	// .attr('x', function() {
	// 	return d3.select(this).attr('prev-x');
	// })
	// .attr('y', function() {
	// 	return d3.select(this).attr('prev-y');
	// });

	// pause audio
	if (currentAudio) currentAudio.pause();
}

function pauseOthers(athlete) {
	bubble_gs.filter(s => s.featured && s.name != athlete).select('.play-button-bg').on('click', play);
	bubble_gs.filter(s => s.featured && s.name != athlete).select('.play-button').attr('xlink:href', './assets/images/play.svg').attr('transform', 'translate(0,0)');

	// pause other audio
	// console.log(`pause all but ${athlete}`)
}

function featuredLabels() {
	featuredBubbleGs = g_bubbles.selectAll('.bubble-g').filter(d => d.featured);

	if (!isMobile) {
		featuredBubbleGs.append('text')
			.attr('class', 'aspirations-label aspirations-label--name')
			.attr('x', 0).attr('y', d => 0)
			.attr('dx', d => d.organizedPos.text_dx).attr('dy', -30)
			.style('text-anchor', d => {
				return d.organizedPos.text_anchor;
			})
			.text(d => d.name == 'Mary Kate Callahan' ? 'Mary Kate' : (d.name == 'Martin Yelling, PhD' ? 'Martin' : d.name.split(' ')[0]))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);

		featuredBubbleGs.append('text')
			.attr('class', 'aspirations-label aspirations-label--name')
			.attr('x', 0).attr('y', d => 0)
			.attr('dx', d => d.organizedPos.text_dx).attr('dy', 4)
			.style('text-anchor', d => d.organizedPos.text_anchor)
			.text(d => d.name == 'Mary Kate Callahan' ? 'Callahan' : (d.name == 'Martin Yelling, PhD' ? 'Yelling' : d.name.split(' ')[1]))
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);

		featuredBubbleGs.append('text')
			.attr('class', 'aspirations-label aspirations-label--title')
			.attr('x', 0).attr('y', d => 0)
			.attr('dx', d => d.organizedPos.text_dx).attr('dy', 28)
			.style('text-anchor', d => d.organizedPos.text_anchor)
			.text(d => d.title)
			.style('opacity', 0)
			.transition().duration(duration.slow).delay(duration.medium)
			.style('opacity', 1);
	}
}

function removeFeaturedLabels() {
	g_bubbles.selectAll('.aspirations-label').transition().duration(duration.medium).style('opacity', 0).remove();
}

function goback(show) {
	goBackButton.classed('is-visible', show);

	goBackButton.on('click', () => {
		unhighlightquote();
		unhighlightFeaturedAthlete();
		util.hideAthletes();
	});

	bottomPanel.select('.aspirations-go-back').select('span').html(lang.translateViz(chapter, 'Nav--Back'))
}

function formatQuote(quote) {
	if (!quote) return '';

	if ((quote[0] == '"' || quote[0] == '“') && (quote[quote.length - 1] == '"' || quote[quote.length - 1] == '”')) {
		return quote.substring(1).slice(0, -1)
	}

	return quote;
}

function getShortQuote() {
	const shortQuotes = otherData.filter(d => d.short === 'TRUE'),
		randomShortQuote = shortQuotes[Math.floor(Math.random() * shortQuotes.length)].quote;

	return randomShortQuote;
}

function resizeAspirations() {
	if (view == 'featured') {
		featuredLabels();
	} else {
		util.hideAthletes();
		removeFeaturedLabels();
	}

	g_bubbles.selectAll('.aspirations-quote').remove();

	if (view != 'all') {
		featuredData.forEach(d => {
			d.r = d.startR;
		});

		otherData.forEach(d => {
			d.r = d.startR;
		});

		simulationFeatured.stop();
		simulationOther.stop();

		featuredBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => d.featured)
			.data(featuredData, d => d.id);

		featuredBubbleGs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		featuredBubbleGs.merge(featuredBubbleGs);

		featuredBubbleGs.selectAll('.bubble').transition().duration(duration.medium)
			.attr('r', d => d.startR);

		otherBubbleGs = g_bubbles.selectAll('.bubble-g')
			.filter(d => !d.featured)
			.data(otherData, d => d.id)

		otherBubbleGs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		otherBubbleGs.merge(otherBubbleGs);

		otherBubbleGs.selectAll('.bubble')
			.style('pointer-events', view === 'featured' ? 'none' : 'all')
			.transition().duration(duration.medium)
			.attr('r', d => d.startR);

		simulationFeatured.nodes(featuredData);
		simulationOther.nodes(otherData);

		//	view == 'featured' ? moveFeaturedMassStatic() : moveFeaturedMass('bottomCenter');
		moveFeaturedMass(view == 'featured' ? 'organized' : 'outOfView');
		moveOtherMass(view == 'featured' ? 'dispersed' : 'topCenter');

	} else {
		data.forEach(d => {
			d.r = d.startR;
		});

		simulation.stop();

		bubble_gs = g_bubbles.selectAll('.bubble-g')
			.data(data, d => d.id);

		bubble_gs.each(function(d) {
			const transform = util.getTransform(d3.select(this).attr('transform'));
			d.x = transform[0];
			d.y = transform[1];
		});

		bubble_gs.merge(bubble_gs);

		bubble_gs.selectAll('.bubble').style('pointer-events', 'all');

		simulation.nodes(data);

		moveMass();
	}

}

function ticked() {
	bubble_gs.attr('transform', d => `translate(${d.x}, ${d.y})`);
}

function reTicked() {
	bubble_gs.attr('transform', d => `translate(${d.x}, ${d.y})`);
}

function tickedBottom() {
	// bubbles.attr('cx', d => Math.max(d.r, Math.min(vizParameters.outerW - d.r, d.x))).attr('cy', d => Math.max(d.r, Math.min(h - d.r, d.y)));

	otherBubbleGs.transition()
		.attr('transform', d => `translate(${Math.max(d.r, Math.min(w - d.r, d.x))}, ${Math.max(d.r, Math.min(h - d.r, d.y))})`);

	// bubbles.attr('cx', function(d) {
	// 	return d.x = Math.max(d.r, Math.min(w - d.r, d.x));
	// }).attr('cy', function(d) {
	// 	return d.y = Math.max(d.r, Math.min(h - d.r, d.y));
	// });
}

function moveMass(loc = 'center') {
	const massCoords = getMassCoords(loc);

	simulation.force('x', d3.forceX().strength(forceStrength).x(d => d.nudgePos ? massCoords.xPos + d.nudgePos.x : massCoords.xPos))
		.force('y', d3.forceY().strength(forceStrength).y(d => d.nudgePos ? massCoords.yPos + d.nudgePos.y : massCoords.yPos))
		.force('charge', d3.forceManyBody().strength(d => charge(d)));

	simulation.alpha(.8).restart();
}

function moveFeaturedMass(loc = 'center') {
	if (loc === 'organized') {
		simulationFeatured.force('x', d3.forceX().strength(forceStrength).x(d => d.organizedPos.x))
			.force('y', d3.forceY().strength(forceStrength).y(d => d.organizedPos.y))

	} else {
		const massCoords = getMassCoords(loc);

		simulationFeatured.force('x', d3.forceX().strength(forceStrength).x(massCoords.xPos))
			.force('y', d3.forceY().strength(forceStrength).y(massCoords.yPos))
	}

	simulationFeatured.force('charge', d3.forceManyBody().strength(d => charge(d)));

	simulationFeatured.alpha(.8).restart();
}

function moveFeaturedMassStatic() {
	featuredBubbleGs.transition().duration(1000).attr('transform', d => {
		return `translate(${d.organizedPos.x}, ${d.organizedPos.y})`
	});
}

function moveOtherMass(loc = 'center') {
	if (loc === 'dispersed') {
		simulationOther.force('x', d3.forceX().strength(forceStrength).x(getDispersedXCoords))
			.force('y', d3.forceY().strength(forceStrength).y(getDispersedYCoords))

	} else {
		const massCoords = getMassCoords(loc);

		simulationOther.force('x', d3.forceX().strength(forceStrength).x(massCoords.xPos))
			.force('y', d3.forceY().strength(forceStrength).y(massCoords.yPos))
	}

	simulationOther.force('charge', d3.forceManyBody().strength(d => charge(d)));
	simulationOther.alpha(.8).restart();
}

function charge(d) {
	return -Math.pow(d.r, 2.1) * forceStrength;
}

function chargeStronger(d) {
	return -Math.pow(d.r, 2.2) * forceStrength;
}

function chargeLighter(d) {
	return -Math.pow(d.r, 2) * forceStrength;
}

function getMassCoords(loc) {
	let xPos = 0,
		yPos = 0;

	if (loc === 'center') {
		xPos = w / 2;
		yPos = h / 2;
	} else if (loc === 'bottomCenter') {
		xPos = vizParameters.outerW / 2;
		yPos = vizParameters.outerH;
	} else if (loc === 'fullCenter') {
		xPos = vizParameters.outerW / 2;
		yPos = vizParameters.outerH / 2;
	} else if (loc === 'outOfView') {
		xPos = vizParameters.outerW / 2;
		yPos = vizParameters.outerH * 1.5;
	} else if (loc === 'outOfViewTop') {
		xPos = vizParameters.outerW / 2;
		yPos = -200;
	} else if (loc === 'topCenter') {
		xPos = vizParameters.outerW / 2;
		yPos = vizParameters.outerH * (2 / 3) / 2;
	}

	return {
		xPos: xPos,
		yPos: yPos,
	}
}

function getDispersedXCoords(d) {
	const currentX = d.x;
	if (currentX < vizParameters.outerW / 2) return util.randomNumber(0, vizParameters.outerW / 2);
	return util.randomNumber(vizParameters.outerW / 2, vizParameters.outerW);
}

function getDispersedYCoords(d) {
	return util.randomNumber((vizParameters.outerH * 3) / 4, vizParameters.outerH);
}

function getVizParameters() {
	const rightW = rightPanel.node().offsetWidth,
		rightH = rightPanel.node().offsetHeight,
		headerH = isMobile ? 56 : 75,
		outerW = container.node().offsetWidth - (isMobile ? 0 : rightW),
		// outerH = container.node().offsetHeight - (isMobile ? rightH : 0);
		outerH = container.node().offsetHeight / (isMobile ? 2 : 1) - (isMobile ? headerH : 0);

	const x = outerW / 2,
		y = outerH / 2;

	const rMaxScale = d3.scaleThreshold().domain([400, 500, 600, 700, 800]).range([12, 14, 16, 23, 29, 32]),
		rOffsetScale = d3.scaleThreshold().domain([500, 1000, 1500]).range([100, 140, 160, 180]);

	const screenMin = Math.min(outerW, outerH);

	return {
		rightW: rightW,
		rightH: rightH,
		headerH: headerH,
		outerW: outerW,
		outerH: outerH,
		x: x,
		y: y,
		// rMax: rMaxScale(screenMin),
		rMax: isMobile ? screenMin * .05 : screenMin * .1,
		rOffset: rOffsetScale(screenMin)
	};
}

function getFeaturedPos(organizedR, expandedR) {
	//POSITIONING TO NUDGE FEATURED IMAGES IN CORNERS OF GROUPED VIZ
	const leftNudge = -5,
		rightNudge = 5,
		upNudge = -5,
		downNudge = 5;

	const nudgePos = [{
			x: leftNudge,
			y: upNudge,
		},
		{
			x: rightNudge,
			y: upNudge,
		},
		{
			x: leftNudge,
			y: downNudge,
		},
		{
			x: rightNudge,
			y: downNudge,
		},
	]

	//POSITIONING FOR WHEN FEATURED ARE ORGANIZED
	const centerX = vizParameters.outerW / 2,
		centerY = vizParameters.outerH * (2 / 3) / 2;

	const leftAligned = centerX - (organizedR),
		rightAligned = centerX + (organizedR),
		topAligned = centerY - (organizedR),
		bottomAligned = centerY + (organizedR);

	const organizedPos = [{
			x: leftAligned,
			y: topAligned,
			text_dx: -organizedR - 10,
			text_anchor: 'end',
		},
		{
			x: rightAligned,
			y: topAligned,
			text_dx: organizedR + 10,
			text_anchor: 'start',
		},
		{
			x: leftAligned,
			y: bottomAligned,
			text_dx: -organizedR - 10,
			text_anchor: 'end',
		},
		{
			x: rightAligned,
			y: bottomAligned,
			text_dx: organizedR + 10,
			text_anchor: 'start',
		},
	]

	//POSITIONING FOR WHEN FEATURED ARE ON CIRCLE
	//NOT USED
	const angle = Math.round(360 / 4);
	const expandedPos = [];

	let i = 0;
	while (i < 4) {
		const angleDeg = angle * i,
			angleRad = (angleDeg - 90) * Math.PI / 180,
			x = (vizParameters.outerW / 2) + (expandedR * Math.cos(angleRad)),
			y = (vizParameters.outerH / 2) - (expandedR * Math.sin(angleRad));

		expandedPos.push({
			x,
			y
		})

		i += 1
	}

	return {
		nudgePos,
		organizedPos,
		expandedPos,
	}
}

function formatData(d, formatFeatured = false) {
	let nodes = [],
		featuredNodes = [],
		otherNodes = [];

	const addRandom = isMobile ? 50 : 75;

	const featuredMinMax = isMobile ? [20, 40] : [60, 100],
		otherSmallMinMax = isMobile ? [8, 16] : [10, 40],
		otherLargeMinMax = isMobile ? [18, 24] : [50, 60],
		fakeSmallMinMax = isMobile ? [2, 4] : [3, 6],
		fakeLargeMinMax = isMobile ? [6, 8] : [8, 14];

	const featuredPos = getFeaturedPos(featuredMinMax[1], vizParameters.rMax * 2);

	featured.forEach((row, i) => {
		const val = util.randomNumber(featuredMinMax[0], featuredMinMax[1]);

		nodes.push({
			val: val,
			fake: false,
			featured: true,
			id: row.id,
			img: row.img,
			imgLarge: row.imgLarge,
			quote: row.quote ? row.quote : '',
			name: lang.translateViz(chapter, row.name),
			title: lang.translateViz(chapter, row.title),
			location: '',
			index: i,
			color: '#F8621F',
			organizedPos: featuredPos.organizedPos[i],
			expandedPos: featuredPos.expandedPos[i],
			nudgePos: featuredPos.nudgePos[i],
		});

		if (formatFeatured) {
			featuredNodes.push({
				val: val,
				fake: false,
				featured: true,
				id: row.id,
				img: row.img,
				imgLarge: row.imgLarge,
				quote: row.quote ? row.quote : '',
				name: lang.translateViz(chapter, row.name),
				title: lang.translateViz(chapter, row.title),
				location: '',
				index: i,
				color: '#F8621F',
				organizedPos: featuredPos.organizedPos[i],
				expandedPos: featuredPos.expandedPos[i],
				nudgePos: featuredPos.nudgePos[i],
			});
		}

	})

	const valsquote = util.randomNumberDist(d.length, [
		[.5, otherSmallMinMax[0], otherSmallMinMax[1]],
		[.5, otherLargeMinMax[0], otherLargeMinMax[1]]
	]);

	d = d.filter(d => d.lang == lang.getCurrentLang());

	d.forEach((row, i) => {
		//const val = util.randomNumber(0, 20);
		const val = valsquote[i];

		nodes.push({
			val: val,
			fake: false,
			featured: false,
			quote: formatQuote(row.quote),
			index: i + featured.length,
			id: `other-${i + featured.length}`,
			color: '#fff'
		});

		if (formatFeatured) {
			otherNodes.push({
				val: val,
				fake: false,
				featured: false,
				quote: formatQuote(row.quote),
				index: i + featured.length,
				id: `other-${i + featured.length}`,
				color: '#fff',
				short: row.short ? row.short : false,
			});
		}
	});

	const valsRandom = util.randomNumberDist(addRandom + 1, [
		[.75, fakeSmallMinMax[0], fakeSmallMinMax[1]],
		[.25, fakeLargeMinMax[0], fakeLargeMinMax[1]]
	]);

	for (let i = 0; i < addRandom + 1; i++) {
		//const val = util.randomNumber(0, 8);
		//console.log(valsRandom[i])
		const val = valsRandom[i];

		nodes.push({
			val: val,
			fake: true,
			featured: false,
			quote: '',
			name: '',
			location: '',
			index: i + featured.length + d.length,
			id: `other-${i + featured.length + d.length}`,
			color: '#5E5E5E'
		});

		if (formatFeatured) {
			otherNodes.push({
				val: val,
				fake: true,
				featured: false,
				quote: '',
				name: '',
				location: '',
				index: i + featured.length + d.length,
				id: `other-${i + featured.length + d.length}`,
				color: '#5E5E5E'
			});
		}
	}

	shuffle(nodes);
	shuffle(featuredNodes);
	shuffle(otherNodes);

	if (formatFeatured) return [featuredNodes, otherNodes];

	return nodes;
}

function shuffle(array) {
	array.sort(() => Math.random() - 0.5);
}

function wrap(text, width) {
	text.each(function() {
		var text = d3.select(this),
			words = text.text().split(/\s+/).reverse(),
			word,
			line = [],
			lineNumber = 0,
			lineHeight = 1.2,
			x = text.attr('x'),
			y = text.attr('y'),
			dy = text.attr('dy') ? text.attr('dy') : 0;

		let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');

		while (word = words.pop()) {
			line.push(word);
			tspan.text(line.join(' '));
			if (tspan.node().getComputedTextLength() > width) {
				line.pop();
				tspan.text(line.join(' '));
				line = [word];
				tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
			}
		}
	});
}

export function getAthlete() {
	return currentAthlete;
}

export default {
	init,
	next,
	setup,
	highlightFeaturedAthlete,
	unhighlightFeaturedAthlete,
	end,
	clear,
	filter,
	getAthlete,
}

d3.selection.prototype.moveToFront = function() {
	return this.each(function() {
		this.parentNode.appendChild(this);
	});
};